import { staff } from '../../api/staff';
import { BrowserFourdApi } from '.';
import { BaseRequest } from 'api';

export class Staff implements staff.Api {
  constructor(private fourd: BrowserFourdApi) {}

  selectStaff(request?: staff.SelectStaffRequest): Promise<staff.Staff[]> {
    return this.fourd.twoWayCall<staff.SelectStaffRequest, staff.Staff[]>(
      request,
      (requestId, request) => {
        this.fourd.call4Dv2('staff.selectStaff', request, requestId);
      },
      (response) => {
        if (
          !this.fourd.leapContext?.hostInfo?.hostVersion ||
          this.fourd.leapContext.hostInfo.hostVersion < '2.4.280.0'
        ) {
          //HSDK-122, fix the incorrect property names, can be removed when minimum version is 2.4
          return response.map((r) => {
            const staff = { ...r, staffId: r.staffGUID, userId: r.userGUID, branchId: r.branchGUID };
            delete staff.staffGUID;
            delete staff.userGUID;
            delete staff.branchGUID;

            return staff;
          });
        }
        return response;
      }
    );
  }

  // getLists(request: BaseRequest): Promise<staff.Staff[]> {
  //   return this.fourd.twoWayCall<BaseRequest, staff.Staff[]>(
  //     request,
  //     (requestId, request) => {
  //       this.fourd.call4Dv2('staff.getLists', request, requestId);
  //     },
  //     (response) => {
  //       let responseData;
  //       try {
  //         responseData = JSON.parse(response);
  //       } catch (e) {
  //         // Unable to parse response.body => response.body is not a stringify object
  //         responseData = response;
  //       }
  //       return responseData;
  //     }
  //   );
  // }
}
